import React from 'react'
import Logo from '../../../assets/img/bigLogo.svg'
import styles from './Loader.module.css'

const Loader = () => {
    return (
        <div className={styles.loader}>
            <img src={Logo} alt="" />
        </div>
    )

}
export default Loader